import { useMemo } from 'react';
import type { MouseEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import DOMPurify from 'dompurify';
import ReactMarkdown from 'react-markdown';

/**
 * Conteúdo do documento. O servidor já sanitiza ao salvar; aqui sanitiza de novo
 * (defesa em profundidade) e links internos do Hub navegam sem recarregar.
 */
export default function DocContent({ html, markdown }: { html?: string | null; markdown?: string | null }) {
    const navigate = useNavigate();
    const clean = useMemo(
        () => (html ? DOMPurify.sanitize(html, { ADD_ATTR: ['target'], FORBID_TAGS: ['style', 'script'] }) : ''),
        [html],
    );

    const onClick = (e: MouseEvent<HTMLDivElement>) => {
        const anchor = (e.target as HTMLElement).closest('a');
        const href = anchor?.getAttribute('href') ?? '';
        if (anchor && href.startsWith('/') && !href.startsWith('//') && !href.startsWith('/api/') && anchor.target !== '_blank') {
            e.preventDefault();
            navigate(href.replace(/^\/v2(?=\/)/, ''));
        }
    };

    if (!html && markdown) {
        return (
            <div className="doc-content">
                <ReactMarkdown>{markdown}</ReactMarkdown>
            </div>
        );
    }

    return <div className="doc-content" onClick={onClick} dangerouslySetInnerHTML={{ __html: clean }} />;
}
